// German for the shell: navigation groups, page titles, the topbar. Registered on load.
import { registerDe } from '../i18n/index.js';

registerDe({
  'Overview': 'Übersicht',
  'CRM': 'CRM',
  'Engagement': 'Auftrag',
  'System': 'System',
  '— no engagement —': '— kein Auftrag —',
  'Toggle theme': 'Design wechseln',
  'Toggle sidebar': 'Seitenleiste ein-/ausblenden',
  'Open menu': 'Menü öffnen',
  'Close menu': 'Menü schliessen',
  'Active engagement': 'Aktiver Auftrag',
  'Log out': 'Abmelden',
}, 'AppShell');
